import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5110f53c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "f10-container 12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_stocks_page = _resolveComponent("stocks-page")!
  const _component_exponent_page = _resolveComponent("exponent-page")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.markettype === '0')
      ? (_openBlock(), _createBlock(_component_stocks_page, { key: 0 }))
      : (_ctx.markettype === '1')
        ? (_openBlock(), _createBlock(_component_exponent_page, {
            key: 1,
            theme: _ctx.theme
          }, null, 8, ["theme"]))
        : _createCommentVNode("", true)
  ]))
}